import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { ReviewStore } from './types';

export const initialState: ReviewStore = {
  status: 'upgrading',
  visibleCount: 10,
  // вариант отображения отзывов
  variant: 'old',
  // для старого типа отзывов
  data: [],
  // для новых отзывов
  reviews: [],
  pagination: {
    page: 1,
    total: 0,
  },
  sorting: {
    order: 'desc',
    field: 'date',
  },
  filters: {},
};

const getState = (state) =>
  typeof state.toJS === 'function' ? state.toJS() : state;

const reviewSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    setVisibleCount: (state, action: PayloadAction<number>) => {
      state.visibleCount = action.payload;
    },
    setVariant: (state, action: PayloadAction<ReviewStore['variant']>) => ({
      ...getState(state),
      variant: action.payload,
    }),
    setReviewsData: (state, action: PayloadAction<ReviewStore['data']>) => {
      // @ts-ignore
      if (typeof state?.toJS === 'function') {
        return {
          // @ts-ignore
          ...state.toJS(),
          data: action.payload,
        };
      }
      const prevState = state.data;
      return {
        ...state,
        data: [...prevState, ...action.payload],
      };
    },
    setData: (
      state,
      action: PayloadAction<
        Pick<ReviewStore, 'reviews' | 'filters' | 'pagination'>
      >,
    ) => {
      const prevStateReviews = state.reviews;
      const { reviews, filters, pagination } = action.payload;
      return {
        ...state,
        reviews: [...prevStateReviews, ...reviews],
        filters,
        pagination,
        status: 'completed',
      };
    },
    setStatus: (state, action: PayloadAction<ReviewStore['status']>) => ({
      ...getState(state),
      status: action.payload,
    }),
    setSorting: (state, action: PayloadAction<ReviewStore['sorting']>) => ({
      ...getState(state),
      sorting: action.payload,
    }),
    setFilters: (state, action: PayloadAction<ReviewStore['filters']>) => ({
      ...getState(state),
      filters: action.payload,
    }),
    changeFilterStatus: (
      state,
      action: PayloadAction<{
        name: string;
        isSelected: boolean;
      }>,
    ) => {
      const { name, isSelected } = action.payload;
      const prevState = state.filters;
      const prevFilterStatus = prevState[name];
      return {
        ...state,
        filters: { ...prevState, [name]: { ...prevFilterStatus, isSelected } },
      };
    },
    clearReviews: (state) => ({
      ...state,
      visibleCount: 10,
      reviews: [],
    }),
  },
});

export const {
  setReviewsData,
  setStatus,
  setVisibleCount,
  setSorting,
  clearReviews,
  setVariant,
  changeFilterStatus,
  setData,
} = reviewSlice.actions;

export const showMoreReviews = createAction('reviews/showMoreReviews');
export const retryDownloadAction = createAction('reviews/retryDownload');
export const showHotelReviewsAction = createAction('reviews/showHotelReviews');

const { name, reducer } = reviewSlice;
export { reducer as default, name };
